import { z } from 'zod';
import type { Question } from '../questionnaire/question';
import { validateConditionAgainstQuestionTarget } from './condition.validator';

type QuestionReposiory = {
  questions: Question[];
};

export type StudyWithQuestionnaires = {
  initialQuestionnaire?: QuestionReposiory;
  emaQuestionnaires?: QuestionReposiory[];
};

export const validateCrossQuestionnaires = (
  study: StudyWithQuestionnaires,
  ctx: z.RefinementCtx,
) => {
  study.emaQuestionnaires?.forEach((emaQuestionnaire, emaIndex) => {
    makeCrossQuestionnaireValidator(
      study.initialQuestionnaire?.questions ?? [],
      ['emaQuestionnaires', emaIndex],
    )(emaQuestionnaire, ctx);
  });
};

export const makeCrossQuestionnaireValidator =
  (initialQuestions: Question[], suffix: (string | number)[] = []) =>
  (questionnaire: QuestionReposiory, ctx: z.RefinementCtx) => {
    const byId = new Map(initialQuestions.map((q) => [q.id, q]));
    questionnaire.questions.forEach((question, questionIndex) => {
      const conditions = question.displayConditions?.conditions ?? [];
      conditions.forEach((condition, conditionIndex) => {
        if (condition.target?.source !== 'initial-question') return;

        const path = (fields: (string | number)[] = []) => [
          ...suffix,
          'questions',
          questionIndex,
          'displayConditions',
          'conditions',
          conditionIndex,
          ...fields,
        ];

        const targetId = condition.target.questionId;
        const targetQuestion = targetId ? byId.get(targetId) : undefined;

        if (!targetQuestion) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: path(['target', 'questionId']),
            message: `Referenced initial question no longer exists`,
          });
          return;
        }

        validateConditionAgainstQuestionTarget(
          condition,
          targetQuestion,
          path,
          ctx,
        );
      });
    });
  };
